import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/declaration';

import { submitDeclaration } from './utils';

export default function* listenSubmitDeclaration() {
  yield takeEvery(actionTypes.submitDriverDeclaration.toString(), submitDeclaration);
}
